module.exports = __webpack_public_path__ + "static/media/status-inativo-icon.51a33689.svg";